import format from 'string-template';
import { Collection } from 'firestorter';

import CollectionName from '../utils/collections';
import { pathPlaceholder } from '../utils/paths';

import BaseDocument from './BaseDocument';

/**
 * Class representing an User Presence.
 * An user presence is a document that tracks the presence of a user.
 *
 * @class UserPresence
 * @extends BaseDocument
 */
class UserSessions extends BaseDocument {
  constructor(id, userId, opts) {
    super(`${format(CollectionName.USER_SESSIONS, { [pathPlaceholder.USER_ID]: userId })}/${id}`, opts);
  }

  get onlineFrom() {
    return this.data.onlineFrom;
  }

  get durationInSeconds() {
    return this.data.durationInSeconds;
  }

  static async getUserOnlineSessionsByUserId(userId, startDate) {
    const userPresenceCollection = new Collection(format(CollectionName.USER_SESSIONS, {
      [pathPlaceholder.USER_ID]: userId,
    }), {
      createDocument: (source, options) => new UserSessions(
        source,
        userId,
        { ...options, disableObserverRefCount: true },
      ),
      query: (query) => query
        .where('onlineFrom', '>=', startDate)
        .orderBy('onlineFrom', 'desc')
      ,
    });
    await userPresenceCollection.fetch();
    return userPresenceCollection;
  }
}

export default UserSessions;
